module.exports = __webpack_public_path__ + "img/logo.aab8ecaf.jpg";